<template>
  <v-card outline class="mt-10 py-4">
    <v-form>
      <v-card-title>Lägg till sektion</v-card-title>
      <v-text-field
        v-model="newSection"
        label="Sektion"
        class="text-field mx-auto"
        append-icon="mdi-file-document-box-plus-outline"
      />
    </v-form>
    <v-card-actions>
      <v-col class="mx-auto px-auto text-center" cols="12" md="6">
        <v-btn @click="addSectionClick" type="submit" color="primary">Lägg till</v-btn>
        
      </v-col>
    </v-card-actions>
  </v-card>
</template>
<script>
import API from "@/services/api.js";
// @group Common
// AddSection component
export default {
  name: "AddSection",
  data: () => ({
    newSection: "",
    id: 0    
  }),
  props: {
    //has profession id ,default empty 
    professionId: ""
  },
  methods: {
    sectionAdded() {
      // Fire addItemClick event
      // @arg The argument is object representing item
      this.$emit("sectionAdded", {
        showAddSection: false,
        showAddButton: true,
        responseId: this.id,
        name: this.newSection,        
      });
      this.newSection = "";
    },
    async addSectionClick() {      
      await API.createSection({
        data: { name: this.newSection, professionId: this.professionId }
      })
        .then(response => {          
          this.$events.fire('showInfo', "'"+this.newSection +"' sparad.")
          this.id = response.data.id;
          this.sectionAdded();
        })
        .catch(error => {
          this.id = 0;
          console.log("There was an error:", error.response);
        });
      
    }
  }
};
</script>